module.exports = __webpack_public_path__ + "static/media/enabledHorizontalAllIcon.fd3752b9.svg";